import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateComponent as InsertEditDateComponent } from './insert-edit/date/date.component';
import { StringComponent as InsertEditStringComponent } from './insert-edit/string/string.component';
import { AutocompleteComponent as InsertEditAutocompleteComponent } from './insert-edit/autocomplete/autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxCurrencyDirective } from 'ngx-currency';
import { DropdownComponent as InsertEditDropdownComponent } from './insert-edit/dropdown/dropdown.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { YearMonthComponent as InsertEditYearMonthComponent } from './insert-edit/year-month/year-month.component';
import { NumberComponent as InsertEditNumberComponent } from './insert-edit/number/number.component';
import { CurrencyComponent as InsertEditCurrencyComponent } from './insert-edit/currency/currency.component';
import { CheckboxComponent as InsertEditCheckboxComponent } from './insert-edit/checkbox/checkbox.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { TextAreaComponent as InsertEditTextAreaComponent } from './insert-edit/text-area/text-area.component';
import { PercentageComponent as InsertEditPercentageComponent } from './insert-edit/percentage/percentage.component';
import { YearComponent as InsertEditYearComponent } from './insert-edit/year/year.component';
import { IConfig, NgxMaskModule } from 'ngx-mask';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    InsertEditDateComponent,
    InsertEditStringComponent,
    InsertEditAutocompleteComponent,
    InsertEditDropdownComponent,
    InsertEditYearMonthComponent,
    InsertEditNumberComponent,
    InsertEditCurrencyComponent,
    InsertEditCheckboxComponent,
    InsertEditTextAreaComponent,
    InsertEditPercentageComponent,
    InsertEditYearComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,

    FontAwesomeModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatMenuModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    MatToolbarModule,

    NgxCurrencyDirective,
    NgxMaskModule.forRoot(maskConfig),
  ],
  exports: [
    InsertEditDateComponent,
    InsertEditStringComponent,
    InsertEditAutocompleteComponent,
    InsertEditDropdownComponent,
    InsertEditYearMonthComponent,
    InsertEditNumberComponent,
    InsertEditCurrencyComponent,
    InsertEditCheckboxComponent,
    InsertEditTextAreaComponent,
    InsertEditPercentageComponent,
    InsertEditYearComponent,
  ]
})
export class DataTableModule { }
